
jQuery(document).ready(function($) {

    carouselFeatured = $("#carousel-featured").owlCarousel({
        items:4,
        mouseDrag: false,
        nav:true,
        dots: true,
        autoplay: false,
        autoplayHoverPause: false,
        smartSpeed: 600,
        dotsSpeed: 270,
        loop: true,
        margin: 32,
        navText: ['<span class="icon-arrow-left"></span>','<span class="icon-arrow-right"></span>'],
        responsive:{
            0:{
                items:1,
                margin: 0
            },            
            480:{
                items:2,
                margin: 16 
            },
            768:{
                items:3,
                margin: 16 
            },
            1024:{
                items:3,
                margin: 32
            },
            1366:{
                items:4,
                margin: 32
            }
        }
    });

});